/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Ocop_UntilInputs */

const vi_shop_ocop_until = /** @type {(inputs: Shop_Ocop_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiệu lực đến`)
};

/**

* @param {Shop_Ocop_UntilInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_ocop_until = /** @type {((inputs?: Shop_Ocop_UntilInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Ocop_UntilInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_ocop_until(inputs)
});